<template>
  <section class="parent">
    <h1>{{ $t('city_template.page_title.' + normalizeCityName(city)) }}</h1>
    <img
      class="image"
      :src="require('@/assets/netherlands/' + `${city}-logo.png`)"
    />
    <p>
      {{ $t(`city_template.page_description.${normalizeCityName(city)}`) }}
    </p>
  </section>
</template>

<script>
import normalizeCityName from '../../../shared/normalizeCityName';

export default {
  props: ['city'],
  methods: {
    normalizeCityName,
  },
};
</script>

<style scoped>
.parent {
  display: grid;
  grid-template-rows: auto;
  margin: 80px var(--global-open-market-margin, 0);
}
h1 {
  font-size: 45px;
  font-family: 'Foco';
  letter-spacing: 0px;
  color: #2b4047;
  opacity: 1;
  text-decoration-line: underline;
  text-decoration-color: #ffdf22;
  text-decoration-thickness: 7px;
}
p {
  font-size: 16px;
  font-family: Lato;
  letter-spacing: 0.16px;
  color: #41565d;
}
@media (min-width: 768px) {
  .parent {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr 1fr;
    row-gap: 60px;
  }
  h1 {
    font-size: 80px;
  }
  p {
    font-size: 20px;
  }
}
</style>
